import { types } from '../actions/registration';

export const { ADD_DOCUMENT, REMOVE_DOCUMENT, INIT_DOCUMENTS, RESET_DOCUMENTS } = types;
const initState = { applicationDocuments: [] };

export const registrationReducer = () => (state = initState, action) => {
	switch (action.type) {
		case INIT_DOCUMENTS: {
			return {applicationDocuments: action.payload}
		}
		case ADD_DOCUMENT: { 
			return { ...state, applicationDocuments: [...state.applicationDocuments, action.payload] }
		};
		case REMOVE_DOCUMENT: {
			return {
				...state, applicationDocuments: [...state.applicationDocuments.filter(doc => (
					doc.documentType !== action.payload
				))]
			}
		};
		case RESET_DOCUMENTS: {return initState}

		default: return state;
	}
};
